import { $getRoot, type EditorState } from "lexical";
import { useCallback } from "react";
import { urlRegex } from "./link-matchers";

const TRACKING_LINK_LENGTH = 55;
export const MEDIAN_MERGE_TAG_LENGTH = 9;

export const useGetCharacterCount = (): ((state: EditorState) => number) => {
  return useCallback((state: EditorState) => {
    return state.read(() => {
      const root = $getRoot();
      const textNodes = root.getAllTextNodes();

      if (!textNodes || textNodes.length === 0) return 0;

      const count = textNodes.reduce((prev, curr) => {
        if (curr.__type === "merge-tag-v2") {
          return prev + MEDIAN_MERGE_TAG_LENGTH;
        }

        let text = curr.__text;
        text = text.replace(urlRegex, () => "_".repeat(TRACKING_LINK_LENGTH));

        return prev + text.length;
      }, 0);

      const lineBreaks = textNodes.filter((x) => x.__type !== "merge-tag-v2").length;
      return count + (lineBreaks > 0 ? lineBreaks - 1 : 0);
    });
  }, []);
};
